import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_CHART_THEME, CHART_THEMES, ChartColorTheme } from '@/constants/chartThemes';

interface ChartThemeStore {
  selectedTheme: string;
  setChartTheme: (themeId: string) => void;
}

export const useChartThemeStore = create(
  persist<ChartThemeStore>(
    (set) => ({
      selectedTheme: DEFAULT_CHART_THEME,
      setChartTheme: (themeId: string) => set({ selectedTheme: themeId }),
    }),
    {
      name: 'chart-theme-store',
    }
  )
);

/**
 * Synchronous function to get chart theme from localStorage
 * This bypasses zustand's async hydration to ensure correct theme on initial chart load
 */
export const getChartThemeFromStorage = (): ChartColorTheme => {
  try {
    const stored = localStorage.getItem('chart-theme-store');
    if (stored) {
      const parsed = JSON.parse(stored);
      const themeId = parsed?.state?.selectedTheme;
      if (themeId) {
        const theme = CHART_THEMES.find((t) => t.id === themeId);
        if (theme) {
          return theme;
        }
      }
    }
  } catch (e) {
    console.warn('[Chart Theme] Failed to read from localStorage:', e);
  }
  return CHART_THEMES.find((t) => t.id === DEFAULT_CHART_THEME) || CHART_THEMES[0];
};
